import { render, staticRenderFns } from "./StepperHeader.vue?vue&type=template&id=4188cf28"
import script from "./StepperHeader.vue?vue&type=script&lang=js"
export * from "./StepperHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports